import { useQuery } from "@tanstack/react-query";
import type { CmmdRuntimeDiagnosticsSnapshot } from "@cmmd-forge/contracts";

import { cmmdApiClient } from "../../environments/cmmdApi";

/**
 * Reads one CMMD-attested diagnostics snapshot for the selected target. This
 * remains deliberately passive: it does not wake, reconnect, or recheck a
 * runtime, and it does not poll a Sprite.
 */
export function useCmmdRuntimeDiagnostics(runtimeId: string | null) {
  const query = useQuery({
    queryKey: ["cmmd", "runtime-diagnostics", runtimeId],
    queryFn: () => cmmdApiClient.getRuntimeDiagnostics(runtimeId!),
    enabled: runtimeId !== null,
    staleTime: 15_000,
    retry: false,
  });

  return {
    snapshot: query.data as CmmdRuntimeDiagnosticsSnapshot | undefined,
    error: query.error instanceof Error ? query.error.message : undefined,
    pending: runtimeId !== null && query.isPending,
    fetching: query.isFetching,
    refresh: query.refetch,
  } as const;
}
